<template>

    <div class="col-sm">
        <div class="icon">
            <i :class="icon + ' fa-3x'"></i>
        </div>
        <div>
            <h2>{{name}}</h2>
            <p>{{text}}</p>
        </div>
    </div>
</template>
<script>

    export default {
        props: {
            icon: null,
            name: null,
            text: null,
        },
    };
</script>
